<template>
  <div class="px-4 py-2">
    <div class="flex items-center px-1">
      <w-button class="mr-2" type="icon" @click="$emit('toggle-option-create-mode', false)">
        <i class="icon-chevron-left-bold" />
      </w-button>
      <label class="font-medium text-black">新增客製化選項</label>
    </div>
    <div class="py-2">
      <div class="bg-white rounded">
        <section class="flex items-center !px-6 py-2">
          <div class="flex-shrink-0 mr-11">
            <span class="text-gray-500">名稱</span>
            <span class="text-red-500">*</span>
          </div>
          <w-input
            :maxLength="40"
            class="flex-grow"
            placeholder="請輸入選項名稱"
            shape="clear"
            v-model="name"
          />
        </section>
        <section class="flex items-baseline !px-6 py-2">
          <div class="flex-shrink-0 mr-13">
            <span class="text-gray-500">
              說明
            </span>
          </div>
          <w-input
            :maxLength="40"
            class="flex-grow"
            placeholder="請輸入選項說明"
            shape="clear"
            show-count
            v-model="note"
          />
        </section>
        <section class="flex items-start !px-6 py-2">
          <div class="flex-shrink-0 mr-3 pt-2">
            <span class="text-gray-500">可選項目</span>
            <span class="text-red-500">*</span>
          </div>
          <div class="flex flex-col w-full">
            <div
              v-for="(item, itemViewIndex) in items"
              :key="`add-option-item-${item.index}`"
              class="flex items-center justify-between mb-2"
            >
              <w-input
                :ref="`new-option-item-name-${item.index}`"
                :maxLength="40"
                class="flex-grow mr-4"
                placeholder="請輸入可選項目名稱"
                shape="clear"
                v-model="item.name"
                @keydown.down.native.stop.prevent="
                  onFocusNext($event, itemViewIndex, 'new-option-item-name')
                "
                @keypress.enter.native.stop.prevent="
                  onCheckAndAddNewItem($event, itemViewIndex, 'new-option-item-name')
                "
                @keydown.right.native.stop.prevent="
                  onFocus($event,`new-option-item-price-${item.index}`)
                "
                @keydown.up.native.stop.prevent="
                  onFocusPre($event, itemViewIndex, 'new-option-item-name')
                "
              />
              <div class="flex items-center flex-shrink-0">
                <span class="mb-[1px] text-black">$</span>
                <w-input
                  :ref="`new-option-item-price-${item.index}`"
                  class="w-20"
                  placeholder="0"
                  shape="clear"
                  type="number"
                  v-model="item.price"
                  @keydown.down.native.stop.prevent="
                    onFocusNext($event, itemViewIndex, 'new-option-item-price')
                  "
                  @keypress.enter.native.stop.prevent="
                    onCheckAndAddNewItem($event, itemViewIndex, 'new-option-item-price')
                  "
                  @keydown.left.native.stop.prevent="
                    onFocus($event, `new-option-item-name-${item.index}`)
                  "
                  @keydown.up.native.stop.prevent="
                    onFocusPre($event, itemViewIndex, 'new-option-item-price')
                  "
                />
              </div>
              <w-button
                v-if="hasMultipleItems"
                class="hover:text-red-500 text-gray-300"
                type="icon"
                @click="onRemoveItem(itemViewIndex)"
              >
                <i class="icon-trash" />
              </w-button>
            </div>
            <div>
              <w-button
                v-if="!hasEmptyItems"
                class="flex-grow-0 flex-shrink-0 my-2"
                color-type="secondary"
                size="sm"
                type="link"
                @click="onAddNewItem()"
              >
                <i class="icon-plus mr-2" />
                <span>新增可選項目</span>
              </w-button>
            </div>
          </div>
        </section>
      </div>
      <section class="flex items-center">
        <label class="font-medium text-black">規則</label>
        <span class="ml-2 my-2 text-gray-300 text-sm">
          *數值為 0 則表示無限制
        </span>
      </section>
      <div class="bg-white rounded">
        <section class="flex flex-wrap items-center px-4 py-2">
          <div class="flex-shrink-0 mr-4">
            <span class="text-gray-500">
              最少選擇幾個項目？
            </span>
          </div>
          <w-counter
            :max="minMax"
            :min="0"
            v-model="min"
          />
        </section>
        <section class="flex flex-wrap items-center px-4 py-2">
          <div class="flex-shrink-0 mr-4">
            <span class="text-gray-500">
              最多選擇幾個項目？
            </span>
          </div>
          <w-counter
            :max="itemsCount"
            :min="0"
            v-model="max"
          />
        </section>
      </div>
    </div>
    <div class="flex items-center justify-end">
      <w-button
        :disabled="disableAdd"
        size="sm"
        @click="onCreateOption"
      >
        確定
      </w-button>
    </div>
  </div>
</template>

<script>
import AddMenuOption from './AddMenuOption';

export default AddMenuOption;
</script>

<style lang="scss" scoped>
@import 'AddMenuOption';
</style>
